/**
 * Moved to `@kiao-voice/ui-kit` so web and desktop share one inline view & edit
 * implementation. Re-exported here so existing call sites keep working.
 *
 * New code should import `InlineEdit` (the component) from the ui-kit directly —
 * it carries the visual as well as the behaviour, which is the half that had
 * drifted into four different per-page treatments.
 */
export {
  useInlineEditable,
  normalizeEditableText,
  INLINE_EDITABLE_MAX_CHARS,
  type InlineEditable,
  type InlineEditableOptions,
} from '@kiao-voice/ui-kit'
